import React from 'react';
import { Icon } from './Icon.js';
export const IconTableColNewRight2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { width: "5.5", height: "12", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m11.25,5.25h-1.25v-1.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25h-1.25c-.414,0-.75.336-.75.75s.336.75.75.75h1.25v1.25c0,.414.336.75.75.75s.75-.336.75-.75v-1.25h1.25c.414,0,.75-.336.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconTableColNewRight2Fill12.js.map